var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-view",attrs:{"id":"ModelView"}},[_c('bimface',{attrs:{"show-error":_vm.tokenError,"view-token":_vm.viewToken,"file-id":_vm.fileId,"from":"FILE","file-type":"FILE","height":"100%","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }